import { createElement } from './PluginCustomProgress';
import { IMedium, ILiveSource } from '../../store/VideoStore';
import { style, direct } from '../../utils/image';
import intl from 'react-intl-universal';
import moment from 'moment';

const fixedPrefix = (val: string, char = '0', len = 2) => {
  while (val && val.length < len) {
    val = char + val;
  }

  return val;
};

const PluginLoading = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(source: IMedium, callback?: () => void) {
        this.el = null;
        this.player = null;
        this.dom = null;
        this.source = source;
        this.noticeTime = moment();
        this.completeCallback = callback;

        this.texts = ['00', '00', '00', '00'];
      },
      needToShowNotice: function() {
        if (this.source && this.source.type == 'live') {
          let detail = this.source.source_detail;
          if (detail && detail.id) {
            if (['wait', 'config'].indexOf(detail.status) >= 0) {
              return true;
            }
          }
        }
        return false;
      },
      setLastTime: function() {
        if (this.source && this.source.type == 'live') {
          let detail = this.source.source_detail;
          if (detail && detail.id && detail.begin_at) {
            this.noticeTime = moment(detail.begin_at);
          }
        }
      },
      createEl: function(el: any, player: any) {
        this.el = el;
        this.player = player;

        if (this.needToShowNotice()) {
          this.setLastTime();
          // 全部条件满足，才会显示直播提醒
          this.dom = createElement('div', {
            className: 'player-notice'
          });

          let desc = createElement('span', {});
          desc.innerText = intl.get('Countdown');

          this.day = createElement('span', {
            className: 'border'
          });

          let dayText = createElement('span', {});
          dayText.innerText = intl.get('Day');

          this.hour = createElement('span', {
            className: 'border'
          });

          let hourText = createElement('span', {});
          hourText.innerText = intl.get('Hour');

          this.minute = createElement('span', {
            className: 'border'
          });

          let minuteText = createElement('span', {});
          minuteText.innerText = intl.get('Minute');

          this.second = createElement('span', {
            className: 'border'
          });

          let secondText = createElement('span', {});
          secondText.innerText = intl.get('Second');

          this.dom.appendChild(desc);
          this.dom.appendChild(this.day);
          this.dom.appendChild(dayText);
          this.dom.appendChild(this.hour);
          this.dom.appendChild(hourText);
          this.dom.appendChild(this.minute);
          this.dom.appendChild(minuteText);
          this.dom.appendChild(this.second);
          this.dom.appendChild(secondText);

          this.el.parentNode.appendChild(this.dom);

          this.start();
        }
      },
      render: function() {
        this.day.innerText = this.texts[0];
        this.hour.innerText = this.texts[1];
        this.minute.innerText = this.texts[2];
        this.second.innerText = this.texts[3];
      },
      start: function() {
        this.calTime();
        this.timer = setInterval(this.calTime.bind(this), 1000);
      },
      calTime: function() {
        let time = this.noticeTime;
        let between = moment(time).valueOf() - Date.now();
        if (between > 0) {
          let duration = moment.duration(moment(time).diff(moment()));
          this.texts = [
            fixedPrefix(duration.days() + ''),
            fixedPrefix(duration.hours() + ''),
            fixedPrefix(duration.minutes() + ''),
            fixedPrefix(duration.seconds() + '')
          ];
          this.render();
        } else {
          this.texts = ['00', '00', '00', '00'];
          if (time) {
            this.finish();
            clearInterval(this.timer);
          }
          this.render();
        }
      },
      finish: function() {
        console.log('countdown complete');
        if (this.completeCallback) {
          this.completeCallback();
        }
      }
    })
  : null;

export default PluginLoading;
